const easing = `cubic-bezier(0.4, 0, 0.2, 1)`

export default function homepageAnimWidget(Site, $) {
  Site.widget('homepage-anim', {
    async _transitionIn() {
      this.duration = 1400
      const hasVisited = !$('body').is('.show-blue')

      this.wrapper = $('.IE-flex-fix')
      this.target = $('#site-wrapper')
      this.body = $('body, html')

      if (hasVisited) {
        this.target.css({ opacity: 1 })
        return
      }

      // Run animation
      this.wrapper.css({
        backgroundColor: '#26498D',
        transition: `background-color 0.3s linear`,
      })

      this.target.css({
        transform: `translate3d(0px, 10vh, 0px) scale(0.95)`,
        transformOrigin: 'top center',
        willChange: 'transform',
      })

      await nextFrame()
      await nextFrame()

      this.target.css({
        transition: `transform ${this.duration / 1000}s ${easing}, opacity ${
          this.duration / 4000
        }s`,
      })
      this.body.css({
        overflow: 'hidden',
        maxHeight: '100vh',
      })

      await wait(1200)
      await idle({ timeout: 2000 })
      await this.animate()

      this.body.css({
        overflow: '',
        maxHeight: '',
      })
      $(window).trigger('resize')
    },
    async animate() {
      this.target.css({
        opacity: 1,
        transform: `translate3d(0px, 0px, 0px) scale(1)`,
      })

      await wait(this.duration * 0.75)

      this.wrapper.css({
        backgroundColor: `rgb(38, 73, 141, 0)`,
      })
    },
  })
}

function nextFrame() {
  return new Promise((resolve) => {
    window.requestAnimationFrame(resolve)
  })
}

function wait(t) {
  return new Promise((resolve) => setTimeout(resolve, t))
}

function idle(opts) {
  return new Promise((resolve) => {
    window.requestIdleCallback(resolve, opts)
  })
}
